import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import { ILauncherVersion } from "src/app/models/application-version/i-launcher-version";

export const launcherVersionPageResolverInjectionToken: InjectionToken<Resolve<IPage<ILauncherVersion>>> = new InjectionToken<Resolve<IPage<ILauncherVersion>>>( "digital-signage-developer-dashboard.LauncherVersionPageResolver" );
